import { useContext } from "react";
import "./index.scss";
import React from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import { useTableContext } from "../../contexts/TableContext";
import { MyContext } from "../../contexts/ContextProvider";

const creationCheck = Yup.object().shape({
  exchange_amount: Yup.number().required("An Exchange Amount is required"),
  exchange_type: Yup.string().required("You must select a type"),
  exchange_currency: Yup.string().required("You must select a currency"),
});

const exchangeType = [
  { value: "BUYING", label: "BUYING" },
  { value: "SELLING", label: "SELLING" },
];

const ExchangeCreationForm = ({ submitForm, closeForm }) => {
  const { loading } = useTableContext();
  const { currencyCode } = useContext(MyContext);

  return (
    <div className="exchange-form">
      <h2>Create An Exchange Rate</h2>
      <Formik
        initialValues={{
          exchange_type: "",
          exchange_amount: "",
          exchange_currency: "",
        }}
        onSubmit={(values) => {
          submitForm(values);
        }}
        validationSchema={creationCheck}
      >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit} id="creationform">
            <div className={`field`}>
              <label htmlFor="exchange_amount">Exchange Amount</label>
              <Field
                name="exchange_amount"
                id="exchange_amount"
                placeholder="Enter Exchange Amount"
                type="number"
                min={0}
                value={values.exchange_amount}
                onChange={handleChange}
              />
              {errors.exchange_amount && touched.exchange_amount ? (
                <div className="error">{errors.exchange_amount}</div>
              ) : null}
            </div>
            <div className={`field select`}>
              <label htmlFor="exchange_currency">Exchange Currency</label>
              <Field
                name="exchange_currency"
                as="select"
                id={`exchange_currency`}
                value={values.exchange_currency}
                onChange={handleChange}
                className="__form-input"
              >
                <option value="">Select a Currency</option>
                {currencyCode.map((exchange_currency, index) => (
                  <option key={index} value={exchange_currency.code}>
                    {exchange_currency.code}
                  </option>
                ))}
              </Field>
              {errors.exchange_currency && touched.exchange_currency ? (
                <div className="error">{errors.exchange_currency}</div>
              ) : null}
            </div>
            <div className={`field select`}>
              <label htmlFor="exchange_type">Select a Exchange Type</label>
              <Field
                name="exchange_type"
                as="select"
                id={`exchange_type`}
                value={values.exchange_type}
                onChange={handleChange}
                className="__form-input"
              >
                <option value="">Select a Type</option>
                {exchangeType.map((exchange_type) => (
                  <option key={exchange_type.value} value={exchange_type.value}>
                    {exchange_type.label}
                  </option>
                ))}
              </Field>
              {errors.exchange_type && touched.exchange_type ? (
                <div className="error">{errors.exchange_type}</div>
              ) : null}
            </div>
            <div className="button-sec">
              <button
                type="button"
                className="cancel-btn"
                disabled={loading}
                onClick={closeForm}
              >
                {!loading && <span>Cancel</span>}
                {loading && <span>Canceling ...</span>}
              </button>
              <button className="create-btn" type="submit" disabled={loading}>
                {!loading && <span>Create</span>}
                {loading && <span>Submitting ...</span>}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};
export default ExchangeCreationForm;
